import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import {
  UpdateCO2CalculatedValuesDocument,
  type CO2CalculatedValuesInput,
} from 'graphql/generated/graphql';

const useUpdateCO2CalculatedValues = () => {
  const [updateCO2CalculatedValuesMutation] = useMutation(UpdateCO2CalculatedValuesDocument);

  const handleUpdate = useCallback(
    async (projectId: string, value: CO2CalculatedValuesInput) => {
      try {
        await updateCO2CalculatedValuesMutation({ variables: { projectId, input: { ...value } } });
      } catch (error) {
        const e = formatGraphqlErrors(error);
        toast.error(e.message);
      }
    },
    [updateCO2CalculatedValuesMutation],
  );
  return handleUpdate;
};

export default useUpdateCO2CalculatedValues;
